import { useEffect, useRef } from "react";
import { useTranslate } from "../../i18n/useTranslationModules";

import { showAlertLong } from "../general-ui/alert/alert-service";
import GoogleLogo from '../../images/logos/Google.svg';
import useTranslationModules from "../../i18n/useTranslationModules";
import Alerts from '../general-ui/alert/alert';

import './google-auth.scss';

const GOOGLE_AUTH_REDIRECT_STORAGE = 'google-auth-redirect';
const GOOGLE_AUTH_REDIRECT_PARAM = 'googleAuthRedirect';

const GoogleAuth = (): JSX.Element => {
	const gapi = useRef<any>();
	useTranslationModules({ language: window.navigator.language.substr(0, 2) });
	const { t } = useTranslate("homepage");

	useEffect(() => {
		const script = document.createElement('script');

		script.onload = () => {
			gapi.current = (window as any).gapi;
			gapi.current.load("auth2", async () => {
				try {
					const inputParams = new URLSearchParams(location.search);
					const googleAuth = await gapi.current.auth2.init({
						client_id: "175600761872-lhuunnd3ain66608mm0v3kvg7bf36fcb.apps.googleusercontent.com"
					});

					const isSignedIn = googleAuth.isSignedIn.get();

					//user is signed in, either from a previous session OR because they were redirected back here after signing in
					if (isSignedIn) {
						//gets here with popup sign in is completed, get user profile data
						const profile = googleAuth.currentUser.get().getBasicProfile();
						const firstName = profile.getGivenName();
						const lastName = profile.getFamilyName();
						const image = profile.getImageUrl();
						const email = profile.getEmail();
						const googleId = profile.getId();
						const googleToken = googleAuth.currentUser.get().getAuthResponse().id_token;

						//parse redirect out of uri input
						const redirectUrl = (() => {
							if (localStorage.getItem(GOOGLE_AUTH_REDIRECT_STORAGE)) {
								return localStorage.getItem(GOOGLE_AUTH_REDIRECT_STORAGE);
							} else {
								const url = inputParams.get(GOOGLE_AUTH_REDIRECT_PARAM);
								if (url) {
									return decodeURIComponent(url);
								}
							}
						})();

						//set in localStorage for reading by the registration form
						const params = new URLSearchParams({ firstName, lastName, image, email, googleId, googleToken });

						//SUCCESS CLAUSE
						//redirect back to target page with signed in user creds
						if (redirectUrl) {

							//remove the storage item to prevent collision with next event if user is already signed in
							localStorage.removeItem(GOOGLE_AUTH_REDIRECT_STORAGE);
							window.location.href = `${redirectUrl}?${params.toString()}`;
						} else {
							//no redirect key, user is stuck here, show error toast
							showAlertLong({
								message: "Sign in Error",
								description: "We ran into an issue redirecting you back to your event page. Please go back and try again.",
								type: "error"
							});
						}
					} else { //get querystring sent here
						//User is not signed in, will redirect to the google form, which will redirect back here, where the isSignedIn clause above should catch and process the user
						const redirectUrl = decodeURIComponent(inputParams.get(GOOGLE_AUTH_REDIRECT_PARAM) as string);

						localStorage.setItem(GOOGLE_AUTH_REDIRECT_STORAGE, redirectUrl);

						//should show popup, allow user to sign in
						await googleAuth.signIn({ ux_mode: "redirect" });
					}
				} catch (e: any) {
					//user could not sign in for one reason or another. Likely sign in was not successful or cookies are disabled on their machine.
					console.error(e);

					//TODO: show user error when they're redirected back to the registration form.
					const errorParams = new URLSearchParams(e);

					const inputParams = new URLSearchParams(location.search);

					const redirectUrl = decodeURIComponent(inputParams.get(GOOGLE_AUTH_REDIRECT_PARAM) as string);

					//user closed popup would be { error: "popup_closed_by_user" }

					if (redirectUrl) {
						window.location.href = `${redirectUrl}?${errorParams.toString()}`;
					} else {
						//no redirect url, show user error toast
						showAlertLong({
							message: "Sign in Error",
							description: "We ran into an issue redirecting you back to your event page. Please go back and try again.",
							type: "error"
						});
					}
				}
			});
		};

		script.src = 'https://apis.google.com/js/platform.js';
		document.body.appendChild(script);
	}, []);

	return (
		<div className="google-auth-wrapper">
			<img src={GoogleLogo} />
			<h3>{t("registration.Signing in with Google", "")}</h3>
			<Alerts />
		</div>
	);
};

export default GoogleAuth;
